import { render } from "./post-wrapper.vue?vue&type=template&id=627b3d36&ts=true"
import script from "./post-wrapper.vue?vue&type=script&lang=ts"
export * from "./post-wrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__